import { createSisumailClient } from '@sisumail/api-client';
import { API_BASE_URL } from '@sisumail/config';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { env } from '../lib/env';

export default function Login() {
    const [secret, setSecret] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        if (secret) {
            try {
                // 1. Verify credentials using a temporary client (satisfies contract)
                // We create a fresh instance to test the new secret immediately

                // ...

                const tempClient = createSisumailClient({
                    baseUrl: env.VITE_API_URL,
                    env: import.meta.env.MODE === 'production' ? 'production' : 'development',
                    adminSecret: secret,
                });

                await tempClient.admin.stats();

                // 2. Persist
                localStorage.setItem('admin_secret', secret);

                // 3. Force Reload to re-initialize API client with new secret
                window.location.href = '/';
            } catch (_err) {
                setError('Invalid secret');
                localStorage.removeItem('admin_secret');
            }
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-900">
            <div className="w-full max-w-sm rounded-lg border border-gray-800 bg-gray-950 p-8 shadow-lg">
                <h1 className="mb-6 font-bold text-2xl text-white">Admin Access</h1>
                <form onSubmit={handleLogin} className="flex flex-col gap-4">
                    <input
                        type="password"
                        className="rounded border border-gray-700 bg-gray-900 px-4 py-2 text-white focus:border-amber-500 focus:outline-none"
                        placeholder="Admin Secret"
                        value={secret}
                        onChange={(e) => setSecret(e.target.value)}
                    />
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button
                        type="submit"
                        className="rounded bg-amber-600 px-4 py-2 font-bold text-white hover:bg-amber-500"
                    >
                        Enter
                    </button>
                </form>
            </div>
        </div>
    );
}
